export const goldTile = "#fcd388";
export const greenTile = "#dee098";
export const blueTile = "#deecf3";
export const orangeTile = "#e0ab98";
export const purpleTile = "#c5a8dd";
export const redTile = "#e098a7";
export const blue2Tile = "#a8a8dd";
export const orange2Tile = "#ffb296";
export const pinkTile = "#e2accd";
export const green2Tile = "#bbcc8a";
export const greyTile = "#cccccc";
export const purple2Tile = "#c0b3cc";
export const red2Tile = "#c1939c";
export const salmonTile = "#FDE1D3";



// WEBPACK FOOTER //
// ./src/constants/classTileColors.js